import { matchesStatusFilter } from "@/lib/documentStatus";
export function StatusLegend({ legendItems, docs, statusFilter, setStatusFilter }) {
  return (
    <div className="flex flex-wrap items-center gap-x-1.5 gap-y-1 mb-3 px-1" data-testid="status-legend">
      {legendItems.map(item => {
        const count = docs.filter(d => {
          return matchesStatusFilter(d, item.statusFilter);
        }).length;
        const isActive = statusFilter === item.statusFilter;
        return (
          <button key={item.label} onClick={() => setStatusFilter(isActive ? null : item.statusFilter)}
            className={`flex items-center gap-1.5 px-2 py-0.5 rounded-full border transition-all text-[11px] ${isActive ? "bg-slate-800 text-white border-slate-800 font-medium" : "bg-white text-slate-500 border-slate-200 hover:border-slate-400"}`}
            data-testid={`status-filter-${item.statusFilter}`}>
            <span className={`inline-block w-2 h-2 rounded-full ${item.dot}`} />
            {item.label} ({count})
          </button>
        );
      })}
      {statusFilter && (
        <button onClick={() => setStatusFilter(null)} className="text-[10px] text-indigo-600 hover:underline ml-1" data-testid="clear-status-filter">
          Tout afficher
        </button>
      )}
    </div>
  );
}
